type props = {
  classWrap?: string
  className?: string
  id: string
  type: string
  name?: string
  label: string
  placeholder?: string
  autocomplete?: string
  required?: boolean
  minLength?: number
  value?: string
  onInput?: any
}

export function TextInput({ classWrap, className, id, type, name, label, placeholder, autocomplete, required, minLength, value, onInput }: props) {
  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onInput) {
      onInput(e.target.value)
    }
  }

  return (
    <div className={`input-wrap ${classWrap}`}>
      <input
        className={`input peer no-autocomplete ${className}`}
        id={id}
        type={type}
        name={name}
        aria-label={label}
        placeholder={placeholder}
        autoComplete={autocomplete}
        required={required}
        minLength={minLength}
        value={value}
        onInput={handleInput}
      />
      <label className="input-label" htmlFor={id}>
        {label}
      </label>
    </div>
  )
}
